import cv from "@techstark/opencv-js";

export default class Line {
    direction: cv.Point = new cv.Point(0, 0);
    len: number = -1;
    start: cv.Point = new cv.Point(-1, -1);
    end: cv.Point = new cv.Point(-1, -1);

    constructor(start?: cv.Point, end?: cv.Point) {
        if (start && end) {
            this.start = start;
            this.end = end;
            const x = end.x - start.x;
            const y = end.y - start.y;
            this.len = Math.sqrt(x * x + y * y);
            this.direction = new cv.Point(x / this.len, y / this.len);
        }
    }

    calculateDirection(line: { start: cv.Point, end: cv.Point }) {
        const x = line.end.x - line.start.x;
        const y = line.end.y - line.start.y;
        const len = Math.sqrt(x * x + y * y);
        this.direction = new cv.Point(x / len, y / len);
    }

    calculateRealLength(sensorWidth: number, sensorHeight: number) {
        const x = (this.end.x - this.start.x) * sensorWidth;
        const y = (this.end.y - this.start.y) * sensorHeight;
        return Math.sqrt(x * x + y * y);
    }

    yByX(x: number): number {
        return this.start.y + (x - this.start.x) * (this.end.y - this.start.y) / (this.end.x - this.start.x);
    }

    xByY(y: number): number {
        return this.start.x + (y - this.start.y) * (this.end.x - this.start.x) / (this.end.y - this.start.y);
    }

    static cloneFrom(original: Line): Line {
        const copy = new Line();
        copy.start = new cv.Point(original.start.x, original.start.y);
        copy.end = new cv.Point(original.end.x, original.end.y);
        copy.len = original.len;
        copy.direction = new cv.Point(original.direction.x, original.direction.y);
        return copy;
    }
}